import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from 'src/utils/colors';

import classes from './Sensor.module.scss';

export interface SensorProps {
  title: string;
  index?: number;
  value?: number;
  maxValue?: number;
  minValue?: number;
  className?: string;
}

const Sensor: FC<SensorProps> = ({
  title,
  index,
  value,
  maxValue = 100,
  minValue = 0,
  className,
}) => {
  const { t } = useTranslation();

  const normalizedValue = ((value - minValue) * 100) / (maxValue - minValue);

  return (
    <div className={classNames(classes.Container, className)}>
      <p>{title ? `${title} (°C)` : `${t('device:sensor_data')} ${index}`}</p>
      {/* Empty divs for showing sensor value */}
      <section>
        <div>
          <div
            style={{
              width: `${value ? normalizedValue : 70}%`,
              backgroundColor: value ? colors()?.colorFumisGreen1 : undefined,
            }}
          />
        </div>
        <p>{value || '/'}</p>
      </section>
    </div>
  );
};

export default Sensor;
